import React, { useState } from "react";
import { InfluencePostCard } from "./InfluencePostCard";
import {
  ChevronRight,
  ChevronLeft,
  TrendingUp,
  Zap,
  Flame,
} from "lucide-react";

export const InfluencerPost = ({ userDatas }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [postType, setPostType] = useState("popular_post");
  const postsPerPage = 4;
  const postsData =
    postType === "popular_post"
      ? userDatas?.top_posts
      : postType === "commercial_post"
      ? userDatas?.commercial_posts
      : [];

  const totalPages = Math?.ceil(postsData?.length / postsPerPage);

  const getCurrentPosts = () => {
    if (!postsData?.length) return [];

    const posts = [];
    for (let i = 0; i < postsPerPage; i++) {
      let dataIndex = (currentPage * postsPerPage + i) % postsData.length;
      if (dataIndex < 0) {
        dataIndex = postsData.length + dataIndex;
      }
      posts.push(postsData[dataIndex]);
    }
    return posts;
  };

  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };

  const handleSetPost = (type) => {
    setPostType(type);
    setCurrentPage(0);
  };

  if (!postsData?.length) return null;

  return (
    <div className="mb-8 p-4 sm:p-6">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center space-y-4 lg:space-y-0 mb-8">
        <div className="space-y-2">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
            Posts
          </h2>
          <p className="text-gray-600 text-sm md:text-base">
            Discover engaging content from our influencer
          </p>
        </div>

        <div className="space-y-3">
          <div className=" w-full sm:w-auto inline-flex ">
            <button
              className={`!px-6 !py-6 !mr-2 !rounded-2xl !font-bold !transition-all duration-300 !flex !items-center !gap-2 !flex-1 !sm:flex-initial !justify-center !group ${
                postType === "popular_post"
                  ? "!bg-gradient-to-br !from-green-500 !via-green-600 !to-emerald-600 !text-white shadow-2xl !shadow-green-500/40 "
                  : "!text-gray-700 !bg-white hover:!shadow-lg border border-green-200 "
              }`}
              onClick={() => handleSetPost("popular_post")}
            >
              <div
                className={`p-1 rounded-lg ${
                  postType === "popular_post"
                    ? "bg-white/20"
                    : "bg-white group-hover:bg-green-200"
                } transition-colors duration-300`}
              >
                <Flame
                  className={`w-5 h-5 ${
                    postType === "popular_post"
                      ? "text-white"
                      : "text-green-600"
                  }`}
                />
              </div>
              <span className="text-base">Trending</span>
            </button>
            <button
              className={`!px-6 !py-6 !rounded-2xl !font-bold !transition-all duration-300 !flex !items-center !gap-2 !flex-1 !sm:flex-initial !justify-center !group ${
                postType === "commercial_post"
                  ? "!bg-gradient-to-br !from-green-500 !via-green-600 !to-emerald-600 !text-white shadow-2xl !shadow-green-500/40 "
                  : "!text-gray-700 !bg-white hover:!shadow-lg  border border-green-200 "
              }`}
              onClick={() => handleSetPost("commercial_post")}
            >
              <div
                className={`p-1 rounded-lg ${
                  postType === "commercial_post"
                    ? "!bg-white/20"
                    : "!bg-white group-hover:bg-green-200"
                } transition-colors duration-300`}
              >
                <Zap
                  className={`w-5 h-5 ${
                    postType === "commercial_post"
                      ? "text-white"
                      : "text-green-600"
                  }`}
                />
              </div>
              <span className="text-base">Commercial</span>
            </button>
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 p-4 bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl border border-green-100">
        <div className="flex items-center space-x-3 mb-3 sm:mb-0">
          <div className="bg-green-100 p-2 rounded-lg">
            <TrendingUp className="w-5 h-5 text-green-600" />
          </div>
          <div>
            <h1 className="text-lg font-semibold text-gray-900">
              {postsData?.length} Posts
            </h1>
            <p className="text-sm text-gray-600">
              {postType === "popular_post"
                ? "Most engaging content"
                : "Sponsored collaborations"}
            </p>
          </div>
        </div>

        {postsData?.length > 4 && (
          <div className="flex items-center space-x-3">
            <div className="flex space-x-1 bg-white p-1 rounded-xl border border-green-200">
              <button
                className="p-2 rounded-lg transition-all duration-200 mr-2 hover:bg-green-600 hover:text-white text-green-600"
                onClick={handlePrevious}
              >
                <ChevronLeft className="w-5 h-5" />
              </button>

              <button
                className="p-2 rounded-lg transition-all duration-200 hover:bg-green-600 hover:text-white text-green-600"
                onClick={handleNext}
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {getCurrentPosts()
          ?.filter((post) => post && post.id)
          ?.map((post) => (
            <InfluencePostCard
              key={post.id}
              id={post.id}
              image={post.thumbnail}
              caption={post.text}
              date={post.created_at}
              likes={post.likes}
              comments={post.comments}
            />
          ))}
      </div>

      {postsData?.length > 4 && (
        <div className="flex justify-center space-x-2 mt-6 lg:hidden">
          {Array.from({ length: totalPages }).map((_, index) => (
            <button
              key={index}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                index === ((currentPage % totalPages) + totalPages) % totalPages
                  ? "bg-green-600 w-6"
                  : "bg-green-200"
              }`}
              onClick={() => setCurrentPage(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
